import React from "react";
import "./AboutMe.css";
import "./common.css";

function AboutMe() {
  const data = [
    { img: require("./../img/react.png"), name: "React" },
    { img: require("./../img/angular.png"), name: "Angular" },
    { img: require("./../img/js.png"), name: "JavaScript" },
    { img: require("./../img/node.png"), name: "NodeJS" },
    { img: require("./../img/next.png"), name: "NextJS" },
  ];
  const creations = [
    {
      name: "Cook it abhi",
      link: "https://cookitabhi.web.app/",
    },
    {
      name: "Event Maker",
      link: "https://myeventsmakers.web.app/",
    },
  ];

  //   const animateMe = (e) => {
  //     e.currentTarget.children[0].style.cssText =
  //       "position: relative; top: -7px;";
  //     e.currentTarget.children[1].style.cssText = "display: block;";
  //   };
  //   const removeAnimation = (e) => {
  //     e.currentTarget.children[0].style.cssText = "position: unset; top: unset;";
  //     e.currentTarget.children[1].style.cssText = "display: none;";
  //   };
  const organization = [
    {
      name: "Capgemini",
      from: "Apr 2017",
      to: "Nov 2020",
      logo: require("../img/Capgemini-Logo.png"),
      isCurrent: false,
    },
    {
      name: "Lowe's",
      from: "Dec 2020",
      to: "Sep 2021",
      logo: require("../img/lowes.png"),
      isCurrent: false,
    },
    {
      name: "Deloitte USI",
      from: "Sep 2021",
      to: "Present",
      logo: require("../img/Deloitte_Logo.png"),
      isCurrent: true,
    },
  ];

  return (
    <>
      <div className="common-div">
        <h3 className="headline">About me</h3>
        <p className="aboutMe-content">
          I am a full stack web developer working in{" "}
          <a
            href="https://www.deloittedigital.com/us/en.html"
            className="hyperlink"
          >
            Deloitte digital
          </a>
          , Bengaluru. having overall experience of 5+ years. I have studied
          bachelors and masters in computer science from Andhra Pradesh.I have
          mostly worked with Javascript technologies such as{" "}
          <a href="https://reactjs.org/" className="hyperlink">
            React
          </a>
          ,{" "}
          <a href="https://angular.io/" className="hyperlink">
            Angular
          </a>
          ,{" "}
          <a href="https://nodejs.org/en/" className="hyperlink">
            NodeJS
          </a>
          ,{" "}
          <a href="https://expressjs.com/" className="hyperlink">
            Express
          </a>{" "}
          and &nbsp;
          <a
            href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
            className="hyperlink"
          >
            Vanilla JavaScript
          </a>
          . I have worked on different domains such as Banking, Retail, Real
          estate, Educational, Trading etc. where i cherished the opportunity of
          learning new things and challenges in everything. I like solving real
          world problems and i keep thinking on making life easier with the help
          of technology. I have good interest in user interfaces and user
          experience (UI &amp; UX). My favourite time use to be when i solve
          Data structures problems and i contribute on dev community sites such
          as &nbsp;
          <a
            href="https://stackoverflow.com/users/10975711/indrakant"
            className="hyperlink"
          >
            stack overflow
          </a>
          .
        </p>
      </div>

      {/* ORGANIZATIONS */}
      <div className="common-div">
        <h3 className="headline">Organizational History</h3>
        <div className="org-main">
          {organization?.map((item) => {
            return (
              <div className="organization-div">
                <img src={item.logo} alt={item.name} />
                <span
                  className="timeline"
                  style={{ color: item.isCurrent ? "#000" : "#666" }}
                >
                  {item.from} &mdash; {item.to}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {/* PROJECTS */}
      <div className="common-div">
        <h3 className="headline">My Tech Stack</h3>
        <div className="tech-container">
          {data?.map((item) => {
            return (
              <div className="tech-item">
                <img src={item.img} alt={item.name} />
              </div>
            );
          })}
        </div>
      </div>

      {/* CREATIONS */}
      <div className="common-div">
        <h3 className="headline">My Creations</h3>
        <div>
          {creations.map((item) => {
            return (
              <a href={item.link} className="creation-link" target="_blank">
                {item.name}
              </a>
            );
          })}
        </div>
      </div>
      {/* <hr className="line" /> */}
    </>
  );
}

export default AboutMe;
